export default "__VITE_ASSET__CnP$TorL__"